import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	pastRenewalsAlert: {
		marginTop: SPACE[16],
	},
});
